// src/components/canvaspuzzle/utils/layoutBoardManager.js
import useStore from '../../../store'; // Импортируем useStore для доступа к ref и state


export function recalculateLayout (boardCanvasRef) {

  mainLayout();
  recalculateBoard(boardCanvasRef);
  calculateInitialOffset(boardCanvasRef)
  calculateTrayPieces();

}


export function mainLayout () {

  const store = useStore.getState();
  const { ref } = store;
  const { puzzle } = ref;
  const { state, config, methods, } = puzzle;

  const titleContainer = {
    left: 0,
    top: 0,
    width: window.innerWidth,
    height: config.titleHeight
  }

  const boardContainer = {
    left: 0,
    top: titleContainer.height,
    width: window.innerWidth,
    height: window.innerHeight - titleContainer.height - (config.user.trayHeight * window.innerHeight),
  }

  const trayContainer = {
    left: 0,
    top: boardContainer.top + boardContainer.height,
    width: window.innerWidth,
    height: window.innerHeight * config.user.trayHeight + 20,
  }
  
  puzzle.layout = {
    titleContainer,
    boardContainer,
    trayContainer,
  }
  
}


export function recalculateBoard(boardCanvasRef) {

  const store = useStore.getState();
  const { ref } = store;
  const { puzzle } = ref;
  const { layout, state, config, methods, boardCanvas } = puzzle;

  const canvasElement = boardCanvasRef?.current || boardCanvas?.element;

  // Проверки на существование элементов и инициализацию
  if (!canvasElement || !state.isInitialized) {
      console.warn("Layout recalculation skipped: Canvas elements or puzzle state invalid.");
      // Можно добавить сброс размеров канвасов, если нужно
       if (canvasElement) {
           canvasElement.width = 0; canvasElement.height = 0;
           canvasElement.style.width = '0px'; canvasElement.style.height = '0px';
       }
      return;
  }

  const dpr = window.devicePixelRatio || 1;

  // --- 1. Расчет размеров ДОСКИ (логических) ---
  const containerWidth = layout.boardContainer.width;
  const containerHeight = layout.boardContainer.height;
  let boardLogicalWidth = 0;
  let boardLogicalHeight = 0;

  const imgWidth = state.imageDimensions?.width;
  const imgHeight = state.imageDimensions?.height;

  if (imgWidth && imgHeight && containerHeight > 0 && containerWidth > 0) {
      const imgRatio = imgWidth / imgHeight;
      const containerRatio = containerWidth / containerHeight;
      const paddingFactor = 0.98; // Небольшой отступ внутри контейнера

      if (imgRatio > containerRatio) {
          boardLogicalWidth = Math.floor(containerWidth * paddingFactor);
          boardLogicalHeight = Math.floor(boardLogicalWidth / imgRatio);
      } else {
          boardLogicalHeight = Math.floor(containerHeight * paddingFactor);
          boardLogicalWidth = Math.floor(boardLogicalHeight * imgRatio);
      }
  } else {
      // Fallback
      boardLogicalWidth = Math.floor(containerWidth * 0.9);
      boardLogicalHeight = Math.floor(containerHeight * 0.9);
      console.warn('Board rectangle calculation fallback used.');
  }

  // --- 2. Обновление состояния ДОСКИ в store ---
  const newBoardDimensions = { width: boardLogicalWidth, height: boardLogicalHeight };
  const widthChanged = Math.abs(newBoardDimensions.width - (state.boardDimensions?.width ?? 0)) > 1;
  const heightChanged = Math.abs(newBoardDimensions.height - (state.boardDimensions?.height ?? 0)) > 1;

  if (widthChanged || heightChanged) {
      state.boardDimensions = newBoardDimensions;
      if (imgWidth > 0) {
          state.imageScale = newBoardDimensions.width / imgWidth;
      } else {
          state.imageScale = 1;
      }
      state.dimensionsCalculated = Date.now();

      // --- 3. Обновление позиций размещенных пазлов ---
      Object.values(state.pieces).forEach(p => {
          if (p.placed && state.boardDimensions?.width && state.boardDimensions?.height) {
              p.currentPos = {
                  x: p.correctPos.x * state.boardDimensions.width,
                  y: p.correctPos.y * state.boardDimensions.height
              };
          }
      });
  }
   // Сохраняем boardRect в layout для информации (x, y не нужны для CSS центрирования)
  // --- 4. Настройка КАНВАСА ДОСКИ ---
  if (boardLogicalWidth > 0 && boardLogicalHeight > 0) {

      boardCanvas.layout.width = boardLogicalWidth;
      boardCanvas.layout.height = boardLogicalHeight;

      canvasElement.width = boardLogicalWidth * dpr;
      canvasElement.height = boardLogicalHeight * dpr;
      canvasElement.style.width = `${boardLogicalWidth}px`;
      canvasElement.style.height = `${boardLogicalHeight}px`;

      const ctx = canvasElement.getContext('2d');
      if (ctx) {
          ctx.scale(dpr, dpr);
          const currentRect = canvasElement.getBoundingClientRect(); // Получаем актуальный rect
           // Сохраняем данные канваса доски
           ref.puzzle.boardCanvas = ref.puzzle.boardCanvas || {};
           Object.assign(ref.puzzle.boardCanvas, {
               element: canvasElement,
               context: ctx,
               rect: currentRect, // Сохраняем актуальный rect
               dimensions: { width: boardLogicalWidth, height: boardLogicalHeight }
           });

          ref.puzzle.state.boardCalculated = Date.now();
      } else {
          console.error(`Failed to get 2D context for board canvas.`);
      }
  } else {
      canvasElement.width = 0; canvasElement.height = 0;
      canvasElement.style.width = '0px'; canvasElement.style.height = '0px';
      ref.puzzle.boardCanvas = { element: canvasElement, context: null, rect: null, dimensions: { width: 0, height: 0 }};
      console.warn(`Skipping setup for board canvas: calculated dimensions are invalid.`);
  }


}

export function calculateInitialOffset(boardCanvasRef) {

  const store = useStore.getState();
  const { ref } = store;
  const { puzzle } = ref;
  const { layout, boardTransform, boardCanvas } = puzzle;

  const canvasElement = boardCanvasRef?.current || boardCanvas?.element;

  if (!boardCanvas) return;
  if (!canvasElement) return;

  const initialOffset = {
    x: (layout.boardContainer.width - boardCanvas.layout.width) / 2,
    y: (layout.boardContainer.height - boardCanvas.layout.height) / 2,
  }

  boardCanvas.layout.x = initialOffset.x;
  boardCanvas.layout.y = initialOffset.y;

}

export function calculateTrayPieces() {

  const store = useStore.getState();
  const { ref } = store;
  const { puzzle } = ref;
  const { layout,state, config, boardTransform, } = puzzle;

  const { pieces, imageScale, pieceBaseDimensions } = state;


  const trayContainer = layout.trayContainer;
  const trayScale = boardTransform.scale; 

  const scaledBaseWidth = pieceBaseDimensions.width * imageScale * trayScale; 

  const trayPadding = scaledBaseWidth * config.trayPaddingFactor; // Значение по умолчанию
  
  const trayGap = scaledBaseWidth * config.user.trayGapFactor; // Значение по умолчанию

  const scrollbarWidth = config.isTouchDevice ? 60 : 20; // В DOM скроллбар не занимает место внутри контента
  const availableWidth = trayContainer.width - scrollbarWidth - trayPadding * 2; // Доступная ширина для ряда кусков

  let currentTrayX = trayPadding; // Начинаем с левого отступа
  let currentTrayY = trayPadding - config.compensation.trayYpx; // Начинаем с верхнего отступа
  let maxRowHeight = 0;
  const pieceLayoutData = {}; // { pieceId: { x, y, width, height } }

  // Фильтруем и сортируем кусочки для трея (те же, что рендерим в DOM)
  const sortedPieceIds = Object.keys(pieces || {})
    .filter(id => {
        const p = pieces[id];
        // Берем неразмещенные ИЛИ видимые "призраки"
        return p && (!p.placed || p.visible);
    })
    .sort((a, b) => (pieces[a]?.order ?? 0) - (pieces[b]?.order ?? 0));

  for (const pieceId of sortedPieceIds) {
    const piece = pieces[pieceId];
    if (!piece || !piece.baseDimensions) continue;

    // Размеры куска в DOM (с учетом imageScale, но без trayScale)
    const displayWidth = piece.baseDimensions.width * imageScale * trayScale;
    const displayHeight = piece.baseDimensions.height * imageScale * trayScale;

    // Перенос на новую строку
    if (currentTrayX > trayPadding &&
        currentTrayX + displayWidth > availableWidth + trayPadding)
    {
      currentTrayX = trayPadding;
      currentTrayY += maxRowHeight + trayGap;
      maxRowHeight = 0;
    } else if (currentTrayX > trayPadding) {
      currentTrayX += trayGap;
    }

    // Сохраняем рассчитанные координаты и размеры для куска
    pieceLayoutData[pieceId] = {
      x: currentTrayX, // Координаты top-left относительно *контента* трея
      y: currentTrayY,
      width: displayWidth,
      height: displayHeight,
    };

    maxRowHeight = Math.max(maxRowHeight, displayHeight);
    currentTrayX += displayWidth;
  }

  const totalContentHeight = currentTrayY + maxRowHeight + trayPadding + 70;
  const maxScrollTop = Math.max(0, totalContentHeight - trayContainer.height);


  layout.trayPiecesLayout = {
    pieceLayoutData, sortedPieceIds, totalContentHeight, maxScrollTop
  }

}


export function calculateOnePiece(pieceId) {


  const store = useStore.getState();
  const { ref } = store;
  const { puzzle } = ref;
  const { state, config, boardTransform, layout } = puzzle;
  const { imageScale, pieces } = state;
  
  const piece = pieces[pieceId];

  const baseTabSizePercent = config.baseTabSizePercent;

  const basicDimensions = {
    width: piece.baseDimensions.width,
    height: piece.baseDimensions.height,
  };

  const maxDimension = Math.max(basicDimensions.width, basicDimensions.height);
  const maxExtension = maxDimension * baseTabSizePercent;
  const maxTotal = maxDimension + maxExtension * 2;

  const basicTabExtensions = {
    width: (maxTotal - basicDimensions.width) / 2,
    height: (maxTotal - basicDimensions.height) / 2,
  };

  const basicTotalDimensions = {
    width: maxTotal,
    height: maxTotal,
  };

  // SCREEN
  const screenDimensions = {
    width: basicDimensions.width * imageScale,
    height: basicDimensions.height * imageScale,
  };

  const screenMaxDimension = Math.max(screenDimensions.width, screenDimensions.height);
  const screenMaxExtension = screenMaxDimension * baseTabSizePercent;
  const screenMaxTotal = screenMaxDimension + screenMaxExtension * 2;

  const screenTabExtensions = {
    width: (screenMaxTotal - screenDimensions.width) / 2,
    height: (screenMaxTotal - screenDimensions.height) / 2,
  };
  const screenTotalDimensions = {
    width: screenMaxTotal,
    height: screenMaxTotal,
  };

  // SCALED

  const scaledDimensions = {
    width: screenDimensions.width * boardTransform.scale,
    height: screenDimensions.height * boardTransform.scale,
  };

  const scaledMaxDimension = Math.max(scaledDimensions.width, scaledDimensions.height);
  const scaledMaxExtension = scaledMaxDimension * baseTabSizePercent;
  const scaledMaxTotal = scaledMaxDimension + scaledMaxExtension * 2;

  const scaledTabExtensions = {
    width: (scaledMaxTotal - scaledDimensions.width) / 2,
    height: (scaledMaxTotal - scaledDimensions.height) / 2,
  };

  const scaledTotalDimensions = {
    width: scaledMaxTotal,
    height: scaledMaxTotal,
  };



  const { pieceLayoutData } = layout.trayPiecesLayout;
  const trayContainer = layout.trayContainer;

  const trayLayoutData = pieceLayoutData[pieceId] || { x: 0, y: 0, width: 0, height: 0 };


  piece.pieceTrayRect = piece.pieceTrayElement?.getBoundingClientRect() || piece.pieceTrayRect;

  const trayPosition = piece.pieceTrayRect ? {
    x: piece.pieceTrayRect.left + scaledTabExtensions.width,
    y: piece.pieceTrayRect.top + scaledTabExtensions.height,
  } : {
    x: trayContainer.left + trayLayoutData.x,
    y: trayContainer.top + trayLayoutData.y,
  }

  
  return {
    basicDimensions,
    basicTabExtensions,
    basicTotalDimensions,
    screenDimensions,
    screenTabExtensions,
    screenTotalDimensions,
    scaledDimensions,
    scaledTabExtensions,
    scaledTotalDimensions,
    trayPosition,
  }




}